import { NAMESPACE } from 'react/api/actions/base';

const actions = {
  licenseStatusModalShowed: `${NAMESPACE}_LICENSE_STATUS_MODAL_SHOWED`,
  licenseStatusModalPositionChanged: `${NAMESPACE}_LICENSE_STATUS_MODAL_POSITION_CHANGED`,
  licenseStatusModalRetracted: `${NAMESPACE}_LICENSE_STATUS_MODAL_RETRACTED`,
  licenseStatusModalExpanded: `${NAMESPACE}_LICENSE_STATUS_MODAL_EXPANDED`,
  licenseStatusModalClosed: `${NAMESPACE}_LICENSE_STATUS_MODAL_CLOSED`
}

const actionCreators = {
  showLicenseStatusModal: (resource, { isCancelable, isExpanded,  position }) => ({
    type: actions.licenseStatusModalShowed,
    payload: {
      resource,
      isCancelable,
      isExpanded,
      position
    }
  }),
  setLicenseStatusModalPosition: ({ x, y }) => ({
    type: actions.licenseStatusModalPositionChanged,
    payload: { x, y }
  }),
  closeLicenseStatusModal: () => ({
    type: actions.licenseStatusModalClosed
  }),
  expandLicenseStatusModal: () => ({
    type: actions.licenseStatusModalExpanded
  }),
  retractLicenseStatusModal: () => ({
    type: actions.licenseStatusModalRetracted
  })
}

export default {
  actions,
  actionCreators
};
